'use client';

import React from 'react';
import { PageType, useGTM } from '@/features/Analytics';
import { DoctorPhones } from '@/features/Phones';
import type { IMedcenterDetails } from '@/entities/medcenter/model/types';
interface Props {
  medcenter: IMedcenterDetails;
}
export const MedcenterPhonesModal: React.FC<Props> = props => {
  const {
    medcenter
  } = props;
  const {
    trackEvent
  } = useGTM(PageType.MEDCENTER_PROFILE);
  const handlePhoneCall = (phoneNumber: {
    type: string;
    phone: string;
  }) => {
    trackEvent('call_medcenter', {
      numberType: phoneNumber.type,
      numberInfo: phoneNumber.phone
    });
  };
  const handleClosePhones = () => {
    trackEvent('close_phonenumber_clinic');
  };
  return <DoctorPhones medcenterId={medcenter.id} title={medcenter.fullName} onPhoneCallGtmEvent={handlePhoneCall} onClosePhonesGtmEvent={handleClosePhones} data-sentry-element="DoctorPhones" data-sentry-component="MedcenterPhonesModal" data-sentry-source-file="MedcenterPhonesModal.tsx" />;
};